import React from 'react';
import './App.css';
import { useScrollReveal } from './hooks/useScrollReveal';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Intro from './components/Intro';
import Timeline from './components/Timeline';
import Values from './components/Values';
import FeaturedProject from './components/FeaturedProject';
import CommunityCTA from './components/CommunityCTA';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import SectionDivider from './components/SectionDivider';

function App() {
  useScrollReveal();

  return (
    <>
      <a href="#main" className="skip-link">Skip to main content</a>
      <Navigation />
      <main id="main">
        <Hero />
        <SectionDivider />
        <Intro />
        <Timeline />
        <SectionDivider />
        <Values />
        <FeaturedProject />
        <SectionDivider />
        <CommunityCTA />
        <ContactForm />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}

export default App;
